module.exports = __webpack_public_path__ + "media/images/dogs/dog-life-expectancy-calculator-what-determines-a-dog-s-lifespan.jpg";